// extracted by mini-css-extract-plugin
module.exports = {"showOnlySmallScreen":"XN","backButtonContainer":"YN"};